module.exports = __webpack_public_path__ + "img/borderWaves.b5381f92.svg";